module.exports = __webpack_public_path__ + "static/media/resume.5aa230c6.pdf";